
import { SceneControl, use } from '@anov/3d-core'
import {IHDRController,SkyMode, HDROptions} from '../types'
import { HDRSky } from '../hdr'
export class HDRController implements IHDRController {
  readonly mode: SkyMode = 'hdr'
  object: HDRSky
  private sceneControl?: SceneControl

  constructor(private options: HDROptions, sceneControl?: SceneControl) {
    this.options = options
    this.sceneControl = sceneControl
    if(!options.path) {
      throw new Error('mode is hdr, path is required')
    }
    this.object = new HDRSky(options, sceneControl)
    this.update(options)
  }

  set rotate(rotate: number) {
    this.object.setRotate(rotate)
  }
  set intensity(intensity: number) {
    this.object.setIntensity(intensity)
  }
  set path(path: string) {
    this.object.setPath(path)
  }
  enter() {}

  exit() {
    const {envManager} = use.useScene(this.sceneControl)
    envManager?.restoreDefault()
  }

  async update(options: HDROptions) {
    this.options = { ...this.options, ...options }
    if (options.path) this.object.setPath(options.path)

    if (options.rotate !== undefined) this.object.setRotate(options.rotate)

    if (options.intensity !== undefined) this.object.setIntensity(options.intensity)
  }
  // setRotate(rotate: number) {
  //   this.object.setRotate(rotate)
  // }
  // setIntensity(intensity: number) {
  //   this.object.setIntensity(intensity)
  // }
  // async setPath(path: string) {
  //   await this.object.setPath(path)
  // }
}
